import { useProductDumpAll } from 'hooks/useProductDumpAll';
import { useProductDumpMain } from 'hooks/useProductDumpMain';
import { useProductDumpMarketData } from 'hooks/useProductDumpMarketData';
import { FC, useCallback } from 'react';

import { DumpButton } from './DumpButton';

interface ProductDumpProps {
  pricingId: string | undefined;
}

export const ProductDumpComponent: FC<ProductDumpProps> = ({ pricingId }) => {
  const { downloadProductDumpAll, isProductDumpAllDownloading } = useProductDumpAll();
  const { downloadProductDumpMain, isProductDumpMainDownloading } = useProductDumpMain();
  const { downloadProductDumpMarketData, isProductDumpMarketDataDownloading } = useProductDumpMarketData();

  const onDumpAll = useCallback(() => downloadProductDumpAll(pricingId!), [pricingId, downloadProductDumpAll]);
  const onDumpMain = useCallback(() => downloadProductDumpMain(pricingId!), [pricingId, downloadProductDumpMain]);
  const onDumpMarketData = useCallback(
    () => downloadProductDumpMarketData(pricingId!),
    [pricingId, downloadProductDumpMarketData],
  );

  return (
    <div className="mt-5 d-flex flex-column" data-e2e="product-dump-content">
      {pricingId && (
        <>
          <DumpButton
            className="btn-primary"
            onClick={onDumpAll}
            labelKey="quoteDetails.product.dump.all.button"
            isDownloading={isProductDumpAllDownloading}
            e2e="download-product-dump-all-btn"
          />
          <div className="d-flex mt-2">
            <DumpButton
              className="btn-secondary flex-grow-1 flex-basis-50 me-1"
              onClick={onDumpMain}
              labelKey="quoteDetails.product.dump.main.button"
              isDownloading={isProductDumpMainDownloading}
              e2e="download-product-dump-main-btn"
            />
            <DumpButton
              className="btn-secondary flex-grow-1 flex-basis-50 ms-1"
              onClick={onDumpMarketData}
              labelKey="quoteDetails.product.dump.market.data.button"
              isDownloading={isProductDumpMarketDataDownloading}
              e2e="download-product-dump-market-data-btn"
            />
          </div>
        </>
      )}
    </div>
  );
};

ProductDumpComponent.displayName = 'ProductDump';
